import type { GamePlayer, GameState } from '@shared/game/types';
import { Avatar } from './Avatar';
import { Icon } from './Icon';

interface PlayersPanelProps {
  game: GameState;
  playerId: string;
}

function pieceStats(player: GamePlayer) {
  return {
    home: player.pieces.filter((piece) => piece.status === 'home').length,
    active: player.pieces.filter((piece) => piece.status === 'active').length,
    goal: player.pieces.filter((piece) => piece.status === 'goal').length,
  };
}

export function PlayersPanel({ game, playerId }: PlayersPanelProps) {
  return (
    <section className="players-panel">
      <div className="panel-heading">
        <span className="eyebrow">Unidades</span>
        <span className="panel-heading__hint">{game.players.filter((player) => !player.forfeited).length} en juego</span>
      </div>
      <div className="players-list">
        {game.players.map((player) => {
          const stats = pieceStats(player);
          const isCurrent = game.currentPlayerId === player.id && game.phase !== 'finished';
          return (
            <div
              key={player.id}
              className={`player-row player-row--${player.color} ${isCurrent ? 'is-current' : ''} ${
                player.forfeited ? 'is-forfeited' : ''
              }`}
            >
              <div className="player-row__avatar">
                <Avatar avatar={player.avatar} size={42} />
                {isCurrent && <span className="player-row__turn" aria-label="Turno actual" />}
              </div>
              <div className="player-row__body">
                <div className="player-row__name">
                  <strong>{player.name}</strong>
                  {player.id === playerId && <span className="badge badge--soft">Tú</span>}
                  {player.isBot && <span className="badge"><Icon name="bot" size={11} /> Bot</span>}
                  {player.forfeited && <span className="badge badge--danger">Abandonó</span>}
                </div>
                <div className="player-row__pieces" aria-label={`${stats.active} en juego, ${stats.goal} en meta, ${stats.home} en base`}>
                  {player.pieces.map((piece) => (
                    <span
                      key={piece.id}
                      className={`piece-pip piece-pip--${player.color} is-${piece.status} ${piece.shielded ? 'is-shielded' : ''}`}
                      title={piece.shielded ? 'Protegida por escudo' : piece.status}
                    />
                  ))}
                  <span className="player-row__stat">{player.score} pts · {stats.goal}/4 meta</span>
                </div>
              </div>
              {!player.connected && !player.isBot && !player.forfeited && (
                <span className="player-row__offline" title="Desconectado"><Icon name="wifi-off" size={15} /></span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
